import { Lang } from '../../enums';
var AjvI18n = /** @class */ (function () {
    function AjvI18n(locale, messages) {
        var _a;
        this.messages = (_a = {},
            _a[Lang.EN_US] = require('ajv-i18n/localize/en'),
            _a[Lang.AR] = require('ajv-i18n/localize/ar'),
            _a[Lang.DE] = require('ajv-i18n/localize/de'),
            _a[Lang.ES] = require('ajv-i18n/localize/es'),
            _a[Lang.FR] = require('ajv-i18n/localize/fr'),
            _a[Lang.HU] = require('ajv-i18n/localize/hu'),
            _a[Lang.IT] = require('ajv-i18n/localize/it'),
            _a[Lang.JA] = require('ajv-i18n/localize/ja'),
            _a[Lang.KO] = require('ajv-i18n/localize/ko'),
            _a[Lang.NB] = require('ajv-i18n/localize/nb'),
            _a[Lang.NL] = require('ajv-i18n/localize/nl'),
            _a[Lang.PL] = require('ajv-i18n/localize/pl'),
            _a[Lang.PT_BR] = require('ajv-i18n/localize/pt-BR'),
            _a[Lang.RU] = require('ajv-i18n/localize/ru'),
            _a[Lang.SK] = require('ajv-i18n/localize/sk'),
            _a[Lang.SV] = require('ajv-i18n/localize/sv'),
            _a[Lang.TH] = require('ajv-i18n/localize/th'),
            _a[Lang.ZH_CN] = require('ajv-i18n/localize/zh'),
            _a[Lang.ZH_TW] = require('ajv-i18n/localize/zh-TW'),
            _a);
        this.locale = locale;
        if (messages) {
            this.messages = messages;
        }
    }
    Object.defineProperty(AjvI18n.prototype, "translate", {
        get: function () {
            return this.messages[this.locale];
        },
        enumerable: true,
        configurable: true
    });
    return AjvI18n;
}());
export { AjvI18n };
//# sourceMappingURL=AjvI18n.js.map